import { render, staticRenderFns } from "./ResultRow.vue?vue&type=template&id=31fb8104&scoped=true"
import script from "./ResultRow.vue?vue&type=script&lang=js"
export * from "./ResultRow.vue?vue&type=script&lang=js"
import style0 from "./ResultRow.vue?vue&type=style&index=0&id=31fb8104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fb8104",
  null
  
)

export default component.exports